export default "/images/trophy.svg?e0170d72a521b7649302ff31be1e7daf";